export const LANGUAGES = {
  en: {
    lang: 'en',
    langTitle: 'English',
    url: 'https://docs.google.com/viewerng/viewer?url=https://assets.khatabook.com/khatabook-website/kb-lending-terms.pdf&embedded=true'
  }
};
